import { Component } from '@angular/core';

@Component({
  selector: 'app-resource-separator',
  templateUrl: './resource-separator.component.html',
  styleUrls: ['./resource-separator.component.scss'],
})
export class ResourceSeparatorComponent {}
